import { authApiService } from '@/api/authApiService';
import { ApiParams } from '@/api/helpers/apiHelpers';
import { ApiResponseType, ListResponseType } from '@/types/sharedTypes';
import { InvoiceCheckType } from '@/types/invoiceVaultTypes';

export const getInvoiceChecksApi = (
  params: ApiParams
): Promise<ApiResponseType<ListResponseType<InvoiceCheckType>>> => {
  return authApiService.GET('/invoice-vault/checks/', params);
};
